<template>
    <div v-if="false"></div>
</template>

<script>
import GeoJSON from 'ol/format/GeoJSON'
import VectorLayer from 'ol/layer/Vector'
import VectorSource from 'ol/source/Vector'
import Feature from 'ol/Feature'
import { getStyle } from '../../styles'

const geoJSON = new GeoJSON()

export default {
    name: 'VectorLayer',
    inject: ['map'],
    created() {
        this.vectorSource = new VectorSource()
        this.vectorLayer = new VectorLayer({
            name: this.name,
            source: this.vectorSource,
            style: (feature) => getStyle(this.map, this.styleName, feature, false),
            properties: {
                selectable: this.selectable,
            },
        })

        this.loadFeatures(this.features)
        this.map.addLayer(this.vectorLayer)
    },
    unmounted() {
        this.map.getLayers().forEach((layer) => {
            if (layer.get('name') === this.vectorLayer.get('name')) {
                this.map.removeLayer(layer)
            }
        })
    },
    props: {
        name: String,
        features: Array,
        styleName: String,
        selectable: Boolean,
    },
    watch: {
        features(features) {
            this.loadFeatures(features)
        },
    },
    methods: {
        loadFeatures(features) {
            if (this.vectorSource) {
                this.vectorSource.clear()
            }

            if (!this.vectorSource) {
                console.log(features)
            }

            this.vectorSource.addFeatures(
                features.map((feature) => {
                    const constructedFeature = new Feature({
                        ...feature,
                        geometry: geoJSON.readGeometry(feature.geometry),
                    })

                    constructedFeature.setId(feature.id)

                    return constructedFeature
                })
            )
        },
    },
}
</script>

<style scoped></style>
